import { getPreloadApi } from "./preloadAccess";
function extractExeIcon(exePath, destPath) {
    // app.getFileIcon generated broken output on windows as of electron 11.0.4
    // (see https://github.com/electron/electron/issues/26918)
    // This issue has not been closed or so much as been replied to, however I was not able to
    // reproduce it so I'm tentatively removing the windows-specific workaround as of
    // Vortex 1.6.0
    /*
    if (process.platform === 'win32') {
      return new Promise((resolve, reject) => {
        iconExtract.extractIconToFile(exePath, destPath, error => {
          if (error !== null) {
            reject(error);
          } else {
            resolve();
          }
        });
      });
    } else {
    */
    return getPreloadApi().app.extractFileIcon(exePath, destPath);
    // }
}
export default extractExeIcon;
